import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { ActiveCampaignEmbedEntry } from "frontend/contentful/schema/blocks";
import { ActiveCampaignEmbed } from "design-system/components/blocks/active-campaign-embed/active-campaign-embed";

export const ContentfulActiveCampaignEmbed =
  createContentfulComponent<ActiveCampaignEmbedEntry>(({ entry }) => {
    if (!entry.fields.embedSourceUrl) {
      return null;
    }

    return <ActiveCampaignEmbed embedSourceUrl={entry.fields.embedSourceUrl} />;
  });
